import { useGet } from "../api-client/useGet";
import { usePost } from "../api-client/usePost";
import { LeadFormData, LeadParams } from "../blocks/LeadForm/LeadFormModal";
import { useTireCompareIdsWithFallback } from "../blocks/Tires/TiresCompareDialog/useTireCompareIds";
import { partTypeTire } from "../constants/partTypes";
import { useLanguage } from "../i18n/useLanguage";
import { useCart } from "../stores/hooks/useCart";
import { useDealerAccountInfo } from "../stores/hooks/useDealerAccountInfo";
import { useSetInfoToast } from "../stores/hooks/useSetInfoToast";

type CreateQuoteContactLead = (params: LeadParams) => Promise<LeadFormData>;

export const useCreateComparisonLead = (): CreateQuoteContactLead => {
  const { get } = useGet();
  const { send } = usePost(
    "/retailSiteWebService/parts/comparison/emailComparison.php"
  );
  const cart = useCart();
  const [language] = useLanguage();
  const [partIds] = useTireCompareIdsWithFallback();
  const { dealerId } = useDealerAccountInfo();
  const setInfoToast = useSetInfoToast();

  const createQuoteContactLead: CreateQuoteContactLead = async ({
    customerEmail,
    customerFirstName,
    customerLastName,
    customerMessage,
    customerPhone,
    generatedBy,
  }): Promise<LeadFormData> => {
    const targetDealerId = cart?.dealerId || dealerId;
    const partIdsString = partIds.join(",");
    await get(`/retailSiteWebService/shopping/lead/createComparisonLead.php`, {
      customerEmail,
      customerFirstName,
      customerLanguage: language,
      customerLastName,
      customerMessage,
      customerPhone,
      generatedBy,
      orderNumber: String(cart?.orderNumber),
      partIds: partIdsString,
      partType: partTypeTire,
      sendCustomerEmail: "false",
      targetDealerId,
    });
    await send({
      customerCurrentLanguage: language,
      customerEmail,
      customerFirstName,
      customerLastName,
      customerNotes: customerMessage,
      customerPhone,
      dealerId: targetDealerId,
      partId: partIdsString,
      partType: "TRE",
    });
    setInfoToast({ message: "leadForm.successMessage" });

    return {
      customerEmail,
      customerFirstName,
      customerLastName,
      customerMessage,
      customerPhone,
      generatedBy,
    };
  };

  return createQuoteContactLead;
};
